import { Content } from "./_components/content";
import { Group } from "./_components/group";
import { ScrollArea } from "./_components/scrollArea";

export const Collapsible = {
    Group,
    ScrollArea,
    Content,
};

export type { GroupProps as CollapsibleGroupProps } from "./_components/group";
export type { ScrollAreaProps as CollapsibleScrollAreaProps } from "./_components/scrollArea";
export type { ContentProps as CollapsibleContentProps } from "./_components/content";
